import { isBrowser } from './browser';
import { LOCAL_STORAGE_KEYS } from '../constants/localStorage';

type LocalStorageKeys =
  (typeof LOCAL_STORAGE_KEYS)[keyof typeof LOCAL_STORAGE_KEYS];

export class StorageService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static setItem(key: LocalStorageKeys, value: any) {
    if (!isBrowser) return;
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(`Error while setting local storage: ${error}`);
    }
  }

  public static getItem(key: LocalStorageKeys) {
    if (!isBrowser) return null;
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    } catch (error) {
      console.error(`Error while retrieving from local storage: ${error}`);
    }
  }

  public static getItemInJSON(key: LocalStorageKeys) {
    if (!isBrowser) return null;
    try {
      const item = localStorage.getItem(key);
      return item;
    } catch (error) {
      console.error(`Error while retrieving from local storage: ${error}`);
    }
  }

  public static removeItem(key: LocalStorageKeys) {
    if (!isBrowser) return null;
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`Error while removing from local storage: ${error}`);
    }
  }
}
